import { createActions } from 'redux-actions'

export const INIT_ROLE_PERMISSION_INFO = "INIT_ROLE_PERMISSION_INFO";

export const REQUEST_ROLE_PERMISSION_START = "REQUEST_ROLE_PERMISSION_START";
export const REQUEST_ROLE_PERMISSION_SUCCESS = "REQUEST_ROLE_PERMISSION_SUCCESS";
export const REQUEST_ROLE_PERMISSION_FAIL = "REQUEST_ROLE_PERMISSION_FAIL";

export const SET_ROLE_PERMISSION_START = "SET_ROLE_PERMISSION_START";
export const SET_ROLE_PERMISSION_SUCCESS = "SET_ROLE_PERMISSION_SUCCESS";
export const SET_ROLE_PERMISSION_FAIL = "SET_ROLE_PERMISSION_FAIL";


export const {
  initRolePermissionInfo,

  requestRolePermissionStart,
  requestRolePermissionSuccess,
  requestRolePermissionFail,

  setRolePermissionStart,
  setRolePermissionSuccess,
  setRolePermissionFail,

} = createActions({

  [INIT_ROLE_PERMISSION_INFO]: (req) => ({ req }),

  [REQUEST_ROLE_PERMISSION_START]: (req) => ({ ...req }),
  [REQUEST_ROLE_PERMISSION_SUCCESS]: (res) => ({ res }),
  [REQUEST_ROLE_PERMISSION_FAIL]: (res) => ({ res }),

  [SET_ROLE_PERMISSION_START]: (req) => ({ ...req }),
  [SET_ROLE_PERMISSION_SUCCESS]: (res) => ({ res }),
  [SET_ROLE_PERMISSION_FAIL]: (res) => ({ res }),

})

